import './App.css';
import { BrowserRouter } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import DemoPage from './components/pages/DemoPage';

function App() {
  return (
    <BrowserRouter>
      <MainLayout>
        <DemoPage />
      </MainLayout>
    </BrowserRouter>
  );
}

export default App;
